import { Dispatch, SetStateAction } from 'react';
import { copyText } from '@srm/ui/lib/clipboard';

export function copyWithToast(value: string, label?: string) {
    void copyText(value, { success: { title: label ? `${label} скопирован` : 'Скопировано' } });
}

export function fmtVal(val: unknown, jsonSliceLen = 60): string {
    if (val === null || val === undefined) return '—';
    if (typeof val === 'boolean') return val ? 'true' : 'false';
    if (Array.isArray(val)) return `[${val.length} строк]`;
    if (typeof val === 'object') {
        try { return JSON.stringify(val).slice(0, jsonSliceLen); } catch { return '[object]'; }
    }
    const s = String(val);
    return s.length > 50 ? s.slice(0, 47) + '...' : s;
}

export function toggleInSet<T>(setState: Dispatch<SetStateAction<Set<T>>>, key: T) {
    setState((prev) => {
        const next = new Set(prev);
        if (next.has(key)) next.delete(key);
        else next.add(key);
        return next;
    });
}

export function downloadBlob(filename: string, content: string, mime: string) {
    const blob = new Blob([content], { type: mime });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
